// extracted by mini-css-extract-plugin
export default {"footer":"LBKo_dQrph5745LGMu_v"};